<app-table
  #tableComponent
  [selectable]="true"
  [preselectedIdentifier]="'contact_id'"
  [preselected]="preselectedContactIds"
  (rowSelected)="onRowSelected($event)"
  *ngIf="tableReady"
  [filters]="tableFilters"
  [columns]="tableColumns"
  [dataSource]="dataSource"
  [dataSourceParams]="tableDataSourceParams"></app-table>
